<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Reviews')}}</div>
        </div>
        <div class="wrap">
            <van-tabs v-model="active" color="#76b900">
                <!-- 全部评论 -->
                <van-tab :title="$t('All reviews')">
                    <van-pull-refresh v-model="refreshingAll" @refresh="onRefreshAll">
                        <van-list
                                v-model="loadingAll"
                                :finished="finishedAll"
                                :finished-text="$t('No more')"
                                @load="onLoadAll">
                            <div class="list">
                                <div class="item" v-for="item in listAll" :key="item.id">
                                    <div class="font-14 font-bold">{{ item.phone }}</div>
                                    <div class="mt-5">{{ item.detail }}</div>
                                    <div class="img-list">
                                        <img
                                                v-for="(img, index) in formatImages(item.images)"
                                                :key="index"
                                                :src="img"
                                                class="thumb"
                                                @click="previewImages(item.images, index)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </van-pull-refresh>
                </van-tab>

                <!-- 我的评论 -->
                <van-tab :title="$t('My reviews')">
                    <van-pull-refresh v-model="refreshingMy" @refresh="onRefreshMy">
                        <van-list
                                v-model="loadingMy"
                                :finished="finishedMy"
                                :finished-text="$t('No more')"
                                @load="onLoadMy">
                            <div class="list">
                                <div class="item" v-for="item in listMy" :key="item.id">
                                    <div>{{ item.detail }}</div>
                                    <div class="img-list">
                                        <img
                                                v-for="(img, index) in formatImages(item.images)"
                                                :key="index"
                                                :src="img"
                                                class="thumb"
                                                @click="previewImages(item.images, index)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </van-pull-refresh>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";
    import { ImagePreview } from 'vant';

    export default {
        name: "review",
        data() {
            return {
                active: 0,

                // 全部评论
                listAll: [],
                pageAll: 1,
                limitAll: 20,
                totalAll: 0,
                loadingAll: false,
                finishedAll: false,
                refreshingAll: false,

                // 我的评论
                listMy: [],
                pageMy: 1,
                limitMy: 20,
                totalMy: 0,
                loadingMy: false,
                finishedMy: false,
                refreshingMy: false,
            }
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {

        },
        methods: {
            // 把逗号分割的字符串转成数组
            formatImages(imgs) {
                if (!imgs) return [];
                return imgs.split(',');
            },
            // 预览大图
            previewImages(imgs, index = 0) {
                const imgArr = this.formatImages(imgs);
                ImagePreview({
                    images: imgArr,
                    startPosition: index
                });
            },
            // 加载全部评论
            async onLoadAll() {
                if (this.finishedAll) return;

                this.loadingAll = true;
                try {
                    Fetch('/user/reviews', {
                        type: 'list',
                        page: this.pageAll,
                        limit: this.limitAll
                    }).then(res => {
                        const data = res.data.reviews;
                        if (this.refreshingAll) {
                            this.listAll = [];
                            this.refreshingAll = false;
                        }

                        this.listAll = [...this.listAll, ...data.data];
                        this.totalAll = data.total;

                        if (this.listAll.length >= data.total) {
                            this.finishedAll = true;
                        } else {
                            this.pageAll++;
                        }
                    })
                } finally {
                    this.loadingAll = false;
                }
            },

            // 下拉刷新全部评论
            onRefreshAll() {
                this.finishedAll = false;
                this.pageAll = 1;
                this.listAll = [];
                this.onLoadAll();
            },

            // 加载我的评论
            async onLoadMy() {
                if (this.finishedMy) return;

                this.loadingMy = true;
                try {
                    Fetch('/user/reviews', {
                        type: 'my',
                        page: this.pageMy,
                        limit: this.limitMy
                    }).then(res => {
                        const data = res.data.reviews;

                        if (this.refreshingMy) {
                            this.listMy = [];
                            this.refreshingMy = false;
                        }

                        this.listMy = [...this.listMy, ...data.data];
                        this.totalMy = data.total;

                        if (this.listMy.length >= data.total) {
                            this.finishedMy = true;
                        } else {
                            this.pageMy++;
                        }
                    })
                } finally {
                    this.loadingMy = false;
                }
            },

            // 下拉刷新我的评论
            onRefreshMy() {
                this.finishedMy = false;
                this.pageMy = 1;
                this.listMy = [];
                this.onLoadMy();
            },
        },
    }
</script>

<style lang="less" scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit{
        color: #000000;
    }
    .wrap {
        padding: 10px;
    }
    .img-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 8px;
    }
    .thumb {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 6px;
        margin-right: 6px;
        margin-bottom: 6px;
    }
    .list {
        margin-top: 20px;
    }
    .item {
        padding: 15px 20px;
        margin-bottom: 10px;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }
</style>